import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteUser: builder.mutation<void, { accountId: string; email: string }>({
      query: ({ accountId, email }) => ({
        url: `/v4/accounts/${accountId}/users/hard?email=${email}&api-version=3.0`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useDeleteUserMutation } = apiSlice;
